import { observer, use$ } from '@legendapp/state/react';
import { Button, Modal, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { configurationState$ } from '../state';
import { freeBetState$ } from '../state/free-bet.state';

export const FreeBetsSummaryModal = observer(() => {
  const { t } = useTranslation();

  const opened = use$(freeBetState$.isSummaryOpened);
  const totalCount = use$(freeBetState$.bonusTotalCount);
  const totalWin = use$(freeBetState$.totalWin);
  const currency = use$(configurationState$.currency);

  const formatter = useMemo(
    () =>
      new Intl.NumberFormat('en-u-nu-latn', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false,
      }),
    []
  );

  return (
    <Modal
      centered={true}
      closeOnClickOutside={false}
      closeOnEscape={false}
      onClose={() => {
        freeBetState$.isSummaryOpened.set(false);
      }}
      opened={opened}
      radius={24}
      size="xs"
      styles={{
        body: {
          paddingLeft: 32,
          paddingRight: 32,
          paddingTop: 48,
          paddingBottom: 48,
        },
      }}
      withCloseButton={false}
    >
      <Stack gap={24}>
        <Stack align="center" gap={4}>
          <Text c="#f6f6f9" fw={500} fz={14} lh="17px">
            {t('freebetsSummaryModal.title')}
          </Text>

          <Text c="#f6f6f9" fw={600} fz={24} lh="29px">
            {t('freebetsSummaryModal.labels.completed')} {totalCount}/
            {totalCount}
          </Text>
        </Stack>

        <Stack align="center" gap={4}>
          <Text c="#f6f6f9" fw={500} fz={14} lh="17px">
            {t('freebetsSummaryModal.labels.winnings')}
          </Text>

          <Text c="#4ade80" fw={600} fz={24} lh="29px">
            {formatter.format(totalWin)} {currency}
          </Text>
        </Stack>

        <Button
          onClick={() => {
            freeBetState$.isSummaryOpened.set(false);
          }}
        >
          {t('freebetsSummaryModal.buttons.close')}
        </Button>
      </Stack>
    </Modal>
  );
});
